import { jsxs as Y, jsx as r, Fragment as $ } from "@emotion/react/jsx-runtime";
import { useMemo as E } from "react";
import { useTheme as x } from "@emotion/react";
import { eachYearOfInterval as q } from "date-fns";
import { MonthYearSelectorsWrapper as y, MonthYearSelector as b, MonthYearOverlay as k, MonthYearItems as v, MonthYearItem as _ } from "./Selectors.styled.js";
import { Text as i } from "../../Text/index.js";
import { useDatePickerContext as z } from "../DatePickerContext.js";
import { getDateSelectorConfig as p, DEFAULT_LOCALE as G, NUMBER_YEAR_DISPLAYED_AFTER_CURRENT as J, NUMBER_YEAR_DISPLAYED_BEFORE_CURRENT as K, NUMBER_OF_MONTHS as Q, isMonthWithinRange as X, isYearWithinRange as Z } from "../helpers.js";
import { DatePickerType as T } from "../../../types/components/dateRangePicker.js";
const ue = ({
  displayMonths: n = !1,
  displayYears: o = !1,
  setDisplayMonths: u,
  setDisplayYears: h,
  changeMonth: w,
  changeYear: A,
  date: B,
  locale: m = G.name,
  selectedMonth: g,
  selectedYear: l
}) => {
  const c = x(), f = /* @__PURE__ */ new Date(), L = (e) => f.getFullYear() === e, O = (e) => f.getFullYear() === B.getFullYear() && f.getMonth() === e, {
    datePickerType: s,
    minDate: C,
    maxDate: R,
    calendarHeight: F
  } = z(), I = () => {
    n && u(!1), h(!o);
  }, N = () => {
    o && h(!1), u(!n);
  }, P = (e) => {
    e.preventDefault();
    const t = parseInt(e.currentTarget?.value, 10);
    A(t), h(!o);
  }, U = (e) => {
    e.preventDefault();
    const t = parseInt(e.currentTarget?.value, 10);
    w(t), u(!n);
  }, S = E(() => p(n, c), [n, c]), D = E(() => p(o, c), [o, c]), d = /* @__PURE__ */ new Date();
  d.setDate(1), d.setMonth(g);
  const W = d.toLocaleString(m, {
    month: "short"
  }), j = (e, t) => e === g ? "white" : t ? "default" : "secondary", H = (e, t) => e === l ? "white" : t ? "default" : "secondary", V = q({
    start: (/* @__PURE__ */ new Date()).setFullYear(l - K),
    end: (/* @__PURE__ */ new Date()).setFullYear(l + J)
  });
  return /* @__PURE__ */ Y(y, { children: [
    ![T.MonthRangePicker, T.MonthSelector].includes(s) && /* @__PURE__ */ Y($, { children: [
      /* @__PURE__ */ r(b, { type: "button", monthSelectorConfig: S, onClick: N, children: /* @__PURE__ */ r(i, { variant: "bodyMBold", color: n ? "primary" : "default", children: W }) }),
      n && /* @__PURE__ */ r(k, { height: F, children: /* @__PURE__ */ r(v, { children: new Array(Q).fill(0).map((e, t) => {
        const a = new Date(l, t), M = X(C, R, a);
        return /* @__PURE__ */ r(_, { type: "button", monthSelectorConfig: S, value: t, onClick: U, "aria-disabled": !M, "aria-selected": g === t, children: /* @__PURE__ */ r(i, { variant: `${O(t) ? "bodyMBold" : "bodyMRegular"}`, color: j(t, M), children: a.toLocaleString(m, {
          month: "short"
        }) }) }, t);
      }) }) })
    ] }),
    /* @__PURE__ */ r(b, { type: "button", monthSelectorConfig: D, onClick: I, children: /* @__PURE__ */ r(i, { variant: "bodyMBold", color: o ? "primary" : "default", children: l ?? (/* @__PURE__ */ new Date()).getFullYear() }) }),
    o && /* @__PURE__ */ r(k, { height: F, type: s, children: /* @__PURE__ */ r(v, { children: V.map((e, t) => {
      const a = Z(C?.getFullYear() ?? null, R?.getFullYear() ?? null, e.getFullYear());
      return /* @__PURE__ */ r(_, { type: "button", monthSelectorConfig: D, value: e.getFullYear(), onClick: P, "aria-disabled": !a, "aria-selected": l === e.getFullYear(), children: /* @__PURE__ */ r(i, { variant: `${L(e.getFullYear()) ? "bodyMBold" : "bodyMRegular"}`, color: H(e.getFullYear(), a), children: e.toLocaleString(m, {
        year: "numeric"
      }) }) }, t);
    }) }) })
  ] });
};
export {
  ue as Selectors
};
